import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { GlobalContextService } from '../../components/global-select/global-context-service';
import { ICustomer } from '../customers/customer-service';
import { IScopePlainAM } from '../scopes/scope-service';

@autoinject
export class ImportContainer {
	scope: IScopePlainAM;
	customer: ICustomer;

	private scopeItemName = 'scope';
	private customerItemName = 'customer';

	constructor(
		private globalContext: GlobalContextService,
		private eventAggregator: EventAggregator) {
	}

	async attached() {
		this.scope = this.globalContext.getItem(this.scopeItemName);
		this.customer = this.globalContext.getItem(this.customerItemName);

		this.eventAggregator.subscribe(`itemChanged-${this.scopeItemName}`, async item => {
			this.scope = item;
		});

		this.eventAggregator.subscribe(`itemChanged-${this.customerItemName}`, async item => {
			this.customer = item;
			this.scope = null;
		});
	}
}
